import _objectSpread from "@babel/runtime/helpers/objectSpread2";
var _FacebookLogo, _FacebookLogo2, _span, _GoogleIcon, _LoadingOverlay;
import { CREHANA_BASE_URL_PRD } from "@crehana/constants";
import { useTranslation } from "@crehana/i18n";
import FacebookLogo from "@crehana/icons/FacebookLogo";
import GoogleIcon from "@crehana/icons/GoogleIcon";
import LoadingOverlay from "../../LoadingOverlay";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SocialButtonsVariantMinimal = function SocialButtonsVariantMinimal(_ref) {
  var shouldRenderFacebookButton = _ref.shouldRenderFacebookButton,
    facebookButtonProps = _ref.facebookButtonProps,
    gmailButtonProps = _ref.gmailButtonProps,
    processingSocialAuth = _ref.processingSocialAuth,
    loadingFacebookAndGoogleScripts = _ref.loadingFacebookAndGoogleScripts,
    currentForm = _ref.currentForm,
    hideFBAuthButton = _ref.hideFBAuthButton,
    hideFBAuthLink = _ref.hideFBAuthLink,
    nextUrl = _ref.nextUrl;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var renderFBAuth = function renderFBAuth() {
    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (hideFBAuthButton && hideFBAuthLink) return null;
    if (hideFBAuthButton && !hideFBAuthLink) {
      return /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread({
        href: "".concat(CREHANA_BASE_URL_PRD, "/login/facebook/?next=").concat(nextUrl)
      }, facebookButtonProps), {}, {
        children: _FacebookLogo || (_FacebookLogo = /*#__PURE__*/_jsx(FacebookLogo, {
          size: 26
        }))
      }));
    }
    return /*#__PURE__*/_jsx("button", _objectSpread(_objectSpread({
      type: "button"
    }, facebookButtonProps), {}, {
      children: _FacebookLogo2 || (_FacebookLogo2 = /*#__PURE__*/_jsx(FacebookLogo, {
        size: 26
      }))
    }));
  };
  var title = currentForm === 'REGISTER_VIEW' ? t('SOCIAL_BUTTON_TEXT') : t('SOCIAL_BUTTON_TEXT_LOGIN');
  return /*#__PURE__*/_jsxs("div", {
    className: "relative flex items-center justify-center w-full",
    children: [/*#__PURE__*/_jsx("span", {
      className: "flex-shrink-0 inline-block mr-16 tw-font-semibold font-caption",
      children: title
    }), shouldRenderFacebookButton && renderFBAuth(), _span || (_span = /*#__PURE__*/_jsx("span", {
      className: "flex-shrink-0 inline-block h-20 mx-12 tw-font-semibold font-caption",
      children: ' o '
    })), /*#__PURE__*/_jsx("button", _objectSpread(_objectSpread({
      type: "button",
      style: {
        display: window.navigator.userAgent.toLowerCase().includes('instagram') ? 'none !important' : 'flex'
      }
    }, gmailButtonProps), {}, {
      children: _GoogleIcon || (_GoogleIcon = /*#__PURE__*/_jsx(GoogleIcon, {
        size: 26
      }))
    })), (processingSocialAuth || loadingFacebookAndGoogleScripts) && (_LoadingOverlay || (_LoadingOverlay = /*#__PURE__*/_jsx(LoadingOverlay, {})))]
  });
};
export default SocialButtonsVariantMinimal;